import excelJS from 'exceljs'
import { save } from 'save-file'
import _ from 'lodash'

const templateListToExcel = async ({ fileName, data }) => {

  const paths = getKeyPaths(data)

  const leafNodes = paths.filter(path => {
    let node = _.get(data, path)
    let hasChildren = typeof node === "object"

    return !hasChildren
  })

  const workbook = new excelJS.Workbook()

  workbook.views = [{
    x: 0, y: 0, width: leafNodes.length, height: 1000,
    firstSheet: 0, activeTab: 1, visibility: 'visible'
  }]

  const worksheet = workbook.addWorksheet("data")

  worksheet.properties.defaultColWidth = 50

  let max_header_row = 1

  const font = { name: 'Arial', size: 12, bold: true }

  leafNodes.map((node, column) => {
    const node_array = node.split(".")

    worksheet.getColumn(column + 1).protection = { locked: false }

    node_array.map((item, row) => {
      const worksheet_row = worksheet.getRow(row + 1)
      const cell = worksheet_row.getCell(column + 1)
      cell.value = item
      cell.alignment = { horizontal: 'center' }
      cell.font = font
      cell.protection = { locked: true }

      if (column > 0) {
        const prevcell = worksheet_row.getCell(column)

        // If we have the same header value as the cell to the left then we merge them
        if (prevcell.value === item) {
          if (prevcell.isMerged) { // Cell to the left is already merged...
            // ID is leafmode cell ID in the merge
            const mergeStart = prevcell.model.master

            // We cannot merge a merged cell, so must unmerge first
            worksheet.unMergeCells(mergeStart)

            // Then do a new merge from original stort cell to our current cell
            const startCellId = mergeStart
            const endCellId = cell.model.address

            worksheet.mergeCells(startCellId, endCellId)
          } else {

            const startCellId = prevcell.model.address
            const endCellId = cell.model.address

            worksheet.mergeCells(startCellId, endCellId)
          }
        }
      }

      max_header_row = Math.max(max_header_row, row + 1)
    })
  })

  worksheet.mergeCells(max_header_row + 1, 1, max_header_row + 1, leafNodes.length)

  // Add a line to demark our header from data  
  const line = worksheet.getRow(max_header_row + 1).getCell(1)
  line.value = "-- -- -- -- --"
  line.alignment = { horizontal: 'center' }
  line.font = font
  line.protection = { locked: true }

  // Now add a row with our sample data
  const worksheet_row = worksheet.getRow(max_header_row + 2)
  leafNodes.map((path, column) => {
    let value = _.get(data, path)
    const cell = worksheet_row.getCell(column + 1)
    cell.value = value
    cell.protection = { locked: false }
  })

  // Create a bunch of blank cells
  for (let r = max_header_row + 3; r < 1000; r++) {
    const data_row = worksheet.getRow(r)
    leafNodes.map((path, column) => {
      const cell = data_row.getCell(column + 1)
      cell.value = { richText: [{ text: "" }] }
      cell.protection = { locked: false }
    })
  }

  // So that we can set the format of those cells to "Text", so that we do not get any date conversions etc.
  leafNodes.map((path, column) => {
    worksheet.getColumn(column + 1).eachCell(c => c.numFmt = '@')
    worksheet.getColumn(column + 1).width = worksheet.properties.defaultColWidth
  })

  // We are protecting our header rows
  await worksheet.protect('', { insertRows: true, deleteRows: true, formatCells: true, })

  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default templateListToExcel


const getKeyPaths = (obj, currentPath = '', result = []) => {
  if (typeof obj !== 'object' || obj === null) {
    return result
  }

  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      const newPath = currentPath === '' ? property : `${currentPath}.${property}`

      if (Array.isArray(obj[property])) {
        obj[property].forEach((item, index) => {
          getKeyPaths(item, `${newPath}[${index}]`, result)
        })
      } else {
        getKeyPaths(obj[property], newPath, result)
      }

      result.push(newPath.replace("[", ".").replace("]", ""))
    }
  }
  return result
}